// src/components/Stripe/CheckoutForm.jsx
import React from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';



const CheckoutForm = () => {
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.jsがまだロードされていない場合は、送信を中断します。
      return;
    }

    const cardElement = elements.getElement(CardElement);

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
    });

    if (error) {
      console.log('[error]', error);
    } else {
      console.log('[PaymentMethod]', paymentMethod);
      // ここでサーバーに支払い情報を送信し、処理を続ける
      // 例: axios.post('/api/payment', { paymentMethodId: paymentMethod.id });
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <CardElement/>
      <button type="submit" disabled={!stripe}>
        今すぐ支払う
      </button>
    </form>
  );
};

export default CheckoutForm;
